var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from '../styled-components';
export var Light = styled.hr(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin: 0.5rem 0;\n  border: 0;\n  border-top: 0.05rem solid ", ";\n  color: transparent;\n"], ["\n  margin: 0.5rem 0;\n  border: 0;\n  border-top: 0.05rem solid ", ";\n  color: transparent;\n"])), function (p) { return p.theme.colorContentAreaBorder; });
var templateObject_1;
